import {
  Action,
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from '@reduxjs/toolkit';
import { ThunkAction } from 'redux-thunk';
import rootReducer, { RootState } from './rootReducer';

const middleware = [...getDefaultMiddleware()];

if (process.env.NODE_ENV === 'development') {
  //middleware.push(logger);
}

let reducer = rootReducer;

if (process.env.NODE_ENV === 'test') {
  reducer = rootReducer || combineReducers({});
}

const store = configureStore({
  reducer,
  middleware,
});

export type AppDispatch = typeof store.dispatch;

export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;

export default store;
